import React from "react";
import IndustryPage from "./IndustryPage";

const FinancialPage: React.FC = () => {
  return <IndustryPage industryKey="financial" />;
};

export default FinancialPage;
